<div style="height:80%; overflow: hidden; ">
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
    <div class="form-group row">
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-6">
            <yt-fw-date-picker-popup id="dpOdDatuma" formControlName="DatumOd" name="txtDatumOd"
              [Label]="'KARTICAMPARTIKLA.DATUMOD.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DatumOd.invalid">
              <span *ngFor="let validation of errorMessages.DatumOd">
                <span class="error-message" *ngIf="fc.DatumOd.hasError(validation.type)">
                  <span [ngClass]="{'slideInRight': fc.DatumOd.hasError(validation.type), 'animated': true}"
                    translate="{{validation.message}}"></span>
                </span>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <yt-fw-date-picker-popup formControlName="DatumDo" name="txtDatumDo"
              [Label]="'KARTICAMPARTIKLA.DATUMDO.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DatumDo.invalid">
              <span *ngFor="let validation of errorMessages.DatumDo">
                <span class="error-message" *ngIf="fc.DatumDo.hasError(validation.type)">
                  <span [ngClass]="{'slideInRight': fc.DatumDo.hasError(validation.type), 'animated': true}"
                    translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <button type="button" class="btn btn-primary" id="btnLoadData" (click)="LoadData()" [disabled]="podaciSuUcitani">
            Učitaj podatke
          </button>
          <button type="button" class="btn btn-primary" id="btnMenjajUslove" (click)="MenjajUslove()" [disabled]="!podaciSuUcitani">
            Menjaj uslove
          </button>
          <button type="button" class="btn btn-primary" id="btnLoadPDF" (click)="LoadPDF()">
            <span class="fa fa-fw fa-print"></span>
            Štampaj
          </button>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist id="ddlRoba"
          [ModelName]="'roba'"
          [GetName]="'get'"
          [ModelProperty]="'Naziv,UnitOfMeasure.Symbol'"
          [OrderBy]="'Naziv'"
          [AllowAddNew]="false"
          formControlName="RobaID"
          [Label]="'KARTICAMPARTIKLA.ROBA.SINGULAR'"
          [ngClass]="{'is-invalid': submitted && fc.RobaID.invalid}">
        </yt-dropdown-picklist>
        <!-- <div class="form-error" *ngIf="submitted && fc.RobaID.invalid"> -->
          <!-- <span *ngFor="let validation of errorMessages.RobaID">
            <span class="error-message" *ngIf="fc.RobaID.hasError(validation.type)"><span
                translate="{{validation.message}}"></span></span>
          </span> -->
        <!-- </div> -->
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist [ModelName]="'komitent'" [GetName]="'get'" [ModelProperty]="'Naziv'" [OrderBy]="'Naziv'"
          [AllowAddNew]="false" formControlName="KomitentID" [Label]="'KARTICAMPARTIKLA.KOMITENT.SINGULAR'">
        </yt-dropdown-picklist>
        <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
          <span *ngFor="let validation of errorMessages.KomitentID">
            <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span
                translate="{{validation.message}}"></span></span>
          </span>
        </div>
        <label>prazan komitent za sve komitente</label>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-right">
        <button type="button" class="btn btn-primary" (click)="LoadSumForm()" [disabled]="!podaciSuUcitani || items.size==0"> 
          U K U P N O
        </button>
      </div>
    </div>
  </form>
  <yt-fw-default-table *ngIf="modelData!=null && modelData.MainList!=null" [Config]="Config" [Items]="items"
    [TableColumns]="modelData.MainList.TableColumns" [Condensed]="CondensedTable" [ShowLoader]="MainItemsLoading"
    (RefreshDataClicked)="RefreshData()">
  </yt-fw-default-table>
</div>

<!-- <label id="lblRoba">Roba</label> -->

<label>
  Vrednosti u koloni "Stanje" su vrednosti NA KRAJU DANA iz kolone "Datum". Vrednost u koloni "Cena nab.", u
  slučaju
  izlaznog dokumenta, predstavlja prosečnu nabavnu cenu artikla na dan dokumenta.
  U vrednostima iz kolone "Cena prod." nije sadržan rabat.
</label>